import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function ServicesPage() {
  const services = [
    {
      title: 'Bounce House Rentals',
      description: 'Premium inflatable bounce houses and slides for all ages. Our extensive collection includes themed bounce houses, combo units with slides, and obstacle courses. All equipment is professionally cleaned, sanitized, and safety-inspected before every rental.',
      features: ['Various sizes available', 'Themed options', 'Safety certified', 'Professional setup included'],
      icon: 'ri-home-smile-fill',
      image: 'https://funaffairs.com/wp-content/uploads/2022/11/balloon-2.png',
      link: '/bounce-house-rentals'
    },
    {
      title: 'Interactive Group Activities',
      description: 'Engaging interactive games and activities perfect for team building, corporate events, and large gatherings. From inflatable sports games to interactive challenges, we have activities that bring people together.',
      features: ['Team building games', 'Competitive activities', 'All age groups', 'Indoor & outdoor options'],
      icon: 'ri-team-fill',
      image: 'https://funaffairs.com/wp-content/uploads/2022/11/balloon-1.png',
      link: '/interactive-activities'
    },
    {
      title: 'Entertainment Services',
      description: 'Professional entertainers including clowns, magicians, face painters, and character appearances. Our talented performers create magical moments and lasting memories for guests of all ages.',
      features: ['Professional performers', 'Character appearances', 'Magic shows', 'Face painting'],
      icon: 'ri-magic-fill',
      image: 'https://funaffairs.com/wp-content/uploads/2022/11/balloon-3.png',
      link: '/entertainment'
    },
    {
      title: 'Party Games',
      description: 'Classic carnival games and modern party activities. From game wheels to skill challenges, ring toss to basketball shootouts, we have everything to keep your guests entertained.',
      features: ['Carnival games', 'Skill challenges', 'Prize options', 'Easy setup'],
      icon: 'ri-gamepad-fill',
      image: 'https://funaffairs.com/wp-content/uploads/2022/11/balloon-2.png',
      link: '/services'
    },
    {
      title: 'Fun Foods Equipment',
      description: 'Add delicious treats to your event with our food equipment rentals. Cotton candy machines, popcorn makers, snow cone machines, and more. We provide everything you need including supplies.',
      features: ['Cotton candy machines', 'Popcorn makers', 'Snow cone machines', 'Supplies included'],
      icon: 'ri-cake-3-fill',
      image: 'https://funaffairs.com/wp-content/uploads/2022/11/balloon-1.png',
      link: '/services'
    },
    {
      title: 'Photo Programs',
      description: 'Create lasting memories with our photo booth services and custom photo keepsakes. Professional photo stations with props, instant prints, and digital sharing options.',
      features: ['Photo booths', 'Custom keepsakes', 'Props included', 'Digital sharing'],
      icon: 'ri-camera-fill',
      image: 'https://funaffairs.com/wp-content/uploads/2022/11/balloon-3.png',
      link: '/services'
    },
    {
      title: 'Custom Wearables',
      description: 'Personalized wearables including custom socks, t-shirts, and accessories. Perfect for corporate events, team building, or party favors that guests will love and remember.',
      features: ['Custom designs', 'Bulk orders', 'Quality materials', 'Fast turnaround'],
      icon: 'ri-t-shirt-fill',
      image: 'https://funaffairs.com/wp-content/uploads/2022/11/balloon-2.png',
      link: '/services'
    },
    {
      title: 'Personalized Programs',
      description: 'Custom party programs and decorations tailored to your event theme. From personalized banners to custom party favors, we help make your event uniquely yours.',
      features: ['Custom decorations', 'Themed packages', 'Personalized favors', 'Design assistance'],
      icon: 'ri-gift-fill',
      image: 'https://funaffairs.com/wp-content/uploads/2022/11/balloon-1.png',
      link: '/services'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <section className="py-24 bg-gradient-to-br from-red-600 to-orange-500">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-5xl sm:text-6xl font-bold text-white mb-6" style={{ fontFamily: 'Sora, sans-serif' }}>
              Our Event Entertainment Services
            </h1>
            <p className="text-xl text-white/95 max-w-3xl mx-auto">
              From bounce houses to entertainment, we provide everything you need for an unforgettable event in Allentown, Bethlehem, Easton, and the Lehigh Valley.
            </p>
          </div>
        </section>

        <section className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="space-y-16">
              {services.map((service, index) => (
                <div 
                  key={index}
                  className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}
                >
                  <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                    <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-red-600 to-orange-500 rounded-2xl mb-6">
                      <i className={`${service.icon} text-3xl text-white`}></i>
                    </div>
                    <h2 className="text-3xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Sora, sans-serif' }}>
                      {service.title}
                    </h2>
                    <p className="text-base text-gray-600 mb-6 leading-relaxed">
                      {service.description}
                    </p>
                    <ul className="space-y-3 mb-8">
                      {service.features.map((feature, idx) => (
                        <li key={idx} className="flex items-center space-x-3">
                          <div className="w-6 h-6 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0">
                            <i className="ri-check-line text-sm text-green-600"></i>
                          </div>
                          <span className="text-sm text-gray-700">{feature}</span>
                        </li>
                      ))}
                    </ul>
                    <Link 
                      to={service.link}
                      className="inline-block bg-red-600 text-white px-8 py-3 rounded-full text-sm font-bold hover:bg-red-700 transition-colors whitespace-nowrap"
                    >
                      Learn More
                    </Link>
                  </div>
                  <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                    <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                      <img 
                        src={service.image}
                        alt={service.title}
                        className="w-full h-96 object-cover"
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-24 bg-gradient-to-br from-red-600 to-orange-500">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-4xl font-bold text-white mb-6" style={{ fontFamily: 'Sora, sans-serif' }}>
              Ready to Book Your Event Entertainment?
            </h2>
            <p className="text-xl text-white/95 mb-8">
              Contact us today for a free quote and let's make your event unforgettable!
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link 
                to="/contact" 
                className="bg-white text-red-600 px-8 py-4 rounded-full text-base font-bold hover:bg-gray-100 transition-colors whitespace-nowrap w-full sm:w-auto"
              >
                Get Free Quote
              </Link>
              <a 
                href="tel:6102532835" 
                className="bg-gray-900 text-white px-8 py-4 rounded-full text-base font-bold hover:bg-gray-800 transition-colors whitespace-nowrap w-full sm:w-auto"
              >
                <i className="ri-phone-fill mr-2"></i>
                (610) 253-2835
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}